import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CardButtonComponent } from "../../components/ui-components/buttons/card-button/card-button.component";
import { CardButtonBackground, CardButtonSize } from "../../components/ui-components/buttons/card-button/card-button.model";

@Component({
  selector: "app-closings-dashboard",
  templateUrl: "./closings-dashboard.component.html",
  styleUrls: ["./closings-dashboard.component.scss"],
  imports: [TranslateModule, CardButtonComponent, CommonModule],
  standalone: true,
})
export class ClosingsDashboardComponent {
  private router = inject(Router);

  CardButtonSize = CardButtonSize;
  CardButtonBackground = CardButtonBackground;

  ngOnInit() { }

  goToMoneyClosing() {
    this.router.navigate(["/closings/money-closing"]);
  }

  goToValuablesClosing() {
    this.router.navigate(["/closings/valuables-closing"]);
  }

}
